<div id="kt_drawer_favorites" class="bg-body" data-kt-drawer="true" data-kt-drawer-name="favorites"
     data-kt-drawer-activate="true" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'280px', 'md': '400px'}"
     data-kt-drawer-direction="end" data-kt-drawer-toggle="#favoriteslist_toggle"
     data-kt-drawer-close="#favoriteslist_close">
  <div class="card w-100 rounded-0">
    <div class="card-header pe-5">
      <div class="card-title">
        <div class="d-flex justify-content-center flex-column me-3">
          <a class="
              fs-4
              fw-bolder
              text-gray-900 text-hover-primary
              me-1
              mb-2
              lh-1
              cursor-pointer
            ">{{"favorite.favoritesList" | translate}}</a>
        </div>
      </div>
      <div class="card-toolbar">
        <div class="btn btn-sm btn-icon btn-active-light-primary" id="favoriteslist_close">
          <span class="svg-icon svg-icon-2"></span>
          <span [inlineSVG]="'./assets/media/icons/duotune/arrows/arr061.svg'" class="svg-icon svg-icon-2"></span>
        </div>
      </div>
    </div>
    <div class="card-body py-2">
      <!-- enter area -->
      <ng-container *ngIf="(isFavoriteUrl$ | async) === false">
        <form (ngSubmit)="saveFavorite(newTitle)">
          <div class="form-group d-flex align-items-center">
            <input type="text" class="form-control required" [(ngModel)]="newTitle" name="name"
                   placeholder="{{'favorite.addPageToFavorite' | translate}}">
            <div class="btn-actions d-flex">
              <!-- Conditional block for spinner or save button -->
              <ng-container *ngIf="(isLoading$ | async) === activatedRoute.url; else saveButtonTemplate">
                <span class="indicator-progress d-block">
                  <span class="spinner-border spinner-border-sm align-middle"></span>
                </span>
              </ng-container>
              <!-- Save button template -->
              <ng-template #saveButtonTemplate>
                <button class="btn btn-icon btn-color-primary btn-active-color-primary bg-hover-light-primary"
                        type="submit">
                  <span class="svg-icon svg-icon-2">
                    <i class="fa-solid fa-floppy-disk fs-4"></i>
                  </span>
                </button>
                <button class="btn btn-icon btn-color-danger btn-active-color-danger bg-hover-light-danger"
                        (click)="newTitle = ''; $event.preventDefault()">
                  <span class="svg-icon svg-icon-2">
                    <i class="fa-solid fa-x fs-4"></i>
                  </span>
                </button>
              </ng-template>
            </div>
          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="getFavorites$ | async as Favorites; else loadingTemplate">
        <div class="d-flex justify-content-center my-5 favorites-item">
          <!-- <ng-container *ngIf="!isNewFavorite;else addNewForm">
            <a class="text-gray-800 fw-bolder text-hover-primary fs-6 px-5 cursor-pointer add-btn" (click)="isNewFavorite = !isNewFavorite">
              {{'favorite.addPageToFavorite' | translate}}
             </a>
          </ng-container>
          <ng-template #addNewForm> -->
          <!-- </ng-template> -->
        </div>
        <div cdkDropList="cdkDropList" class="scroll-y droplist" [cdkDropListData]="Favorites"
             (cdkDropListDropped)="drop($event,Favorites)">
          <div class="position-relative favorites-item" [cdkDragData]="doc"
               *ngFor="let doc of Favorites | slice : startPage:paginationLimit ; let i = index;let isLast = last" cdkDrag>
            <div class="d-flex align-items-sm-center">
              <div class="symbol symbol-40px symbol-2by2 me-3">
                <i class="fa" [ngClass]="doc?.icon" aria-hidden="true"></i>
              </div>
              <div class="d-flex flex-row-fluid flex-nowrap align-items-center" *ngIf="!editMode[i]; else editTemplate">
                <div class="flex-grow-1 me-auto">
                  <a (click)="openPlayerWindow(doc?.url,doc?.type)" [routerLinkActiveOptions]="{exact: true}"
                     routerLinkActive="text-primary" class="fw-bolder text-hover-primary fs-6 cursor-pointer">
                    {{doc.name}}
                  </a>
                  <div class="text-gray-400 mt-1 fw-semibold fs-6">
                    {{doc.url}}</div>
                </div>
                <ng-container *ngIf="(isLoading$ | async) === doc?.url; else elseTemplate">
                  <span class="indicator-progress" [style.display]="'block'">
                    <span class="spinner-border spinner-border-sm align-middle"></span>
                  </span>
                </ng-container>
                <ng-template #elseTemplate>
                  <div class="d-flex flex-nowrap">
                    <button type="button"
                            class="btn btn-icon btn-sm h-auto btn-color-gray-400 btn-active-color-primary justify-content-end edit-btn"
                            (click)="toggleEditMode(i,doc?.name,doc?.url)">
                      <span class="svg-icon svg-icon-2">
                        <i class="fa-solid fa-pen-to-square fs-4"></i>
                      </span>
                    </button>
                    <button type="button" (click)="delete(doc)"
                            class="btn btn-icon btn-sm h-auto btn-color-gray-400 btn-active-color-danger justify-content-end">
                      <span class="svg-icon svg-icon-2">
                        <i class="fa-solid fa-trash fs-4"></i>
                      </span>
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
            <!-- edit area -->
            <ng-template #editTemplate>
              <form (ngSubmit)="saveFavorite(newTitles[i], i, doc?.id, newUrls[i])">
                <div class="form-group d-flex align-items-center">
                  <div class="input-container flex-grow-1">
                    <input type="text" class="form-control mb-2" [(ngModel)]="newTitles[i]" name="name"
                           placeholder="{{doc.name}}">
                    <input type="text" class="form-control" [(ngModel)]="newUrls[i]" name="url"
                           placeholder="{{doc.url}}">
                  </div>

                  <div class="btn-actions d-flex align-items-center">
                    <!-- Conditional block for spinner or save button -->
                    <ng-container *ngIf="(isLoading$ | async) === doc?.url; else saveButtonTemplate">
                      <span class="indicator-progress mr-2"> <!-- added mr-2 for some spacing -->
                        <span class="spinner-border spinner-border-sm align-middle"></span>
                      </span>
                    </ng-container>

                    <!-- Save button template -->
                    <ng-template #saveButtonTemplate>
                      <button class="btn btn-icon btn-color-primary btn-active-color-primary bg-hover-light-primary"
                              type="submit">
                        <span class="svg-icon svg-icon-2">
                          <i class="fa-solid fa-floppy-disk fs-4"></i>
                        </span>
                      </button>
                    </ng-template>

                    <button class="btn btn-icon btn-color-danger btn-active-color-danger bg-hover-light-danger ml-2"
                            (click)="toggleEditMode(i,doc?.name,doc?.url)">
                      <span class="svg-icon svg-icon-2">
                        <i class="fa-solid fa-x fs-4"></i>
                      </span>
                    </button>
                  </div>

                </div>
              </form>
            </ng-template>

            <div class="separator separator-dashed my-3" *ngIf="!isLast"></div>
          </div>
      <div class="d-flex flex-column justify-content-around mt-2"> <a class="btn btn-color-primary btn-outline btn-active-color-primary bg-hover-light-primary mb-3" *ngIf ="paginationLimit <= Favorites.length" (click)="showMoreItems()">
       {{"terms.showMore" | translate}}
      </a>
        <a class="btn btn-color-primary btn-outline btn-active-color-primary bg-hover-light-primary " *ngIf ="paginationLimit > 5" (click)="showLessItems()">
          {{"terms.showLess" | translate}}
        </a></div>
        </div>
      </ng-container>
      <ng-template #loadingTemplate>
        <ngx-shimmer-loading [width]="'100%'" [height]="'40px'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [width]="'100%'" [height]="'40px'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [width]="'100%'" [height]="'40px'"></ngx-shimmer-loading>
      </ng-template>
    </div>
  </div>
</div>
